/**
 * 本人が承認を積める担当者かの照合（`getApprovalAccess`）の TanStack Query ラッパー。
 *
 * 承認の一覧と承認操作はprocedure（`listTermChangesAcrossPjs` / `approveTermChanges`）を
 * 包む `spec-pj-element-queries.ts` が持つ。ここに残るのは、サイドバーの入口の出し分けにも使う
 * 担当者の照合だけである。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 本人が承認を積める担当者かの照合を TanStack Query のフックとして画面へ供給する。
 * @graph-connects rpcClient [calls] specPj.getApprovalAccess
 */
import type { GetApprovalAccessOutput } from '@cortex/domain-spec-console';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { rpcClient } from '../../lib/orpc.js';
import { queryKeys } from '../../lib/query-keys.js';

/**
 * 本人が承認を積める担当者かを読む。サイドバーの「承認一覧」と承認一覧の画面が使う。
 *
 * @returns 担当者かの照合結果
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 本人が承認を積める担当者かを取得する。
 * @graph-connects rpcClient [calls] specPj.getApprovalAccess
 */
export function useApprovalAccess(): UseQueryResult<GetApprovalAccessOutput> {
  return useQuery({
    queryKey: queryKeys.specPj.approvalAccess(),
    queryFn: () => rpcClient.specPj.getApprovalAccess({}),
  });
}
